<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')" />
		<fieldset class="form__group">
			<FormControlInsightCategory
                v-show="!formData.newCategory"
                v-model="formData.category"
                name="folder"
                :valueFormat="'object'"
                v-validate="(!formData.newCategory) ? 'required' : ''"
            />
			<template>
				<div v-if="formData.newCategory">
					<div class="form__group">
						<input
                            id="new-name"
                            name="newName"
                            class="form__control"
                            v-model="formData.newName"
                            placeholder="Enter category name here..."
                            v-validate
                            required
                        />
						<label for="new-name" class="form__label">Name</label>
						<div class="form__validation">{{ errors.first('newName') }}</div>
					</div>
					<FormControlInsightCategory
                        v-model="formData.newParent"
                        name="newParent"
                        v-validate="(formData.newCategory) ? 'required' : ''"
                    />
				</div>
			</template>

			<div class="form__group" v-if="can('createInsightCategories')">
				<a v-if="!formData.newCategory" @click.prevent="formData.newCategory = true">Create category</a>
				<a v-else @click.prevent="formData.newCategory = false">Use existing category</a>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" @click.prevent="submit" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import { mapGetters } from 'vuex';
	import ValidationAlert from '@components/ValidationAlert';
	import FormControlInsightCategory from '@components/Form/Control/FormControlInsightCategory';
	import InsightFormStep from './InsightFormStep';

	export default {
		name: 'InsightFormStep2',
		mixins: [InsightFormStep],
		components: {
			FormControlInsightCategory,
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					newCategory: false,
					newName: null,
					newParent: 0,
					category: null,
				}
			}
		},
		computed: {
			...mapGetters([
				'can',
			])
		}
	}
</script>
